export default __webpack_public_path__ + "static/replay-dark-1b7f361f3c61daca170aa9b662edff40.png";